import styled from 'styled-components'

export const AvatarWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`
